import { useRef } from "react";
import { StepList } from "~/components/build/Show/components/Sidebar/StepList";
import {
  DisplayMode,
  useFilterStore,
} from "~/components/build/Show/components/Sidebar/useFilterStore";
import { useSteps } from "~/components/build/Show/lib/useSteps";
import { Table } from "~/components/build/Show/pages/steps/table";

export const MobileStepsView = () => {
  const { isLoading } = useSteps();
  const filters = useFilterStore((state) => state.filterBy);
  const scrollRef = useRef<HTMLDivElement>(null);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (Features.HideBuildSidebar) {
    return (
      <div className="relative h-full w-full flex-auto">
        <Table className="absolute" />
      </div>
    );
  }

  return (
    <div className="absolute h-full w-full overflow-auto" ref={scrollRef}>
      <StepList filters={filters} forceDisplayMode={DisplayMode.Pipeline} scrollRef={scrollRef} />
    </div>
  );
};
